import { Injectable, inject } from '@angular/core';
import { Auth, onAuthStateChanged, signInWithEmailAndPassword, User as FirebaseUser, signOut } from '@angular/fire/auth';
import { Database, ref as dbRef, get as dbGet } from '@angular/fire/database';
import { Router } from '@angular/router';
import { AppContextServiceService } from './app-context-service.service';

@Injectable({
  providedIn: 'root',
})
export class UnitService {
  private auth = inject(Auth);
  private db = inject(Database);
  private router = inject(Router);
  private appContextService = inject(AppContextServiceService)

    private resetAppContext() {
      this.appContextService.selectedUnit = null;
      this.appContextService.clientName = null;
      this.appContextService.userUnits = null;
      this.appContextService.currentUserId = null;
      this.appContextService.authedUser = null;
    }

    onStateChange() {
      return onAuthStateChanged(this.auth, async (firebaseUser: FirebaseUser | null) => {
        this.resetAppContext();
        if (!firebaseUser) {
          this.appContextService.authedUser = false
          this.router.navigateByUrl('login', { replaceUrl: true });
          return
        } else {
          try {
            this.appContextService.authedUser = true
            this.appContextService.currentUserId = firebaseUser.uid
            const unitsSnap = await dbGet(dbRef(this.db, `usersAdminApp/${firebaseUser.uid}/clientGroups/0`));
            const clientGroup = unitsSnap.val();
            const units = clientGroup?.units || [];
            this.appContextService.userUnits= units;
            return
          } catch (err) {
            console.error("Error during unit service state change:", err);
            return
          }

        }
      });
  }

  signInWithEmail(email: string, password: string): Promise<any> {
    return signInWithEmailAndPassword(this.auth, email, password);
  }
  async logout(): Promise<void> {
    await signOut(this.auth);
  }

}
